export class User {
    id?: string;
    name?: string;
    pass?: string;
    email?: string;
    phone?: string;
    otp?: string;
    re_password?: string;
    usertype?: string;
}